"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _mobx = require("mobx");
var _lodash = require("lodash");
var _stores = require("@seedlang/stores");
var _serializr = require("serializr");
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var DictionaryNavigation = exports["default"] = (_dec = _mobx.observable.ref, _class = /*#__PURE__*/function () {
  function DictionaryNavigation(context) {
    _classCallCheck(this, DictionaryNavigation);
    _initializerDefineProperty(this, "context", _descriptor, this);
    _initializerDefineProperty(this, "loading", _descriptor2, this);
    _initializerDefineProperty(this, "error", _descriptor3, this);
    this.context = context;
  }
  return _createClass(DictionaryNavigation, [{
    key: "word",
    value: function word(wordId) {
      var _this$context;
      return ((_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.words) === null || _this$context === void 0 ? void 0 : _this$context[wordId]) || _stores.WordStore.indexData.find(function (word) {
        return word.id === wordId;
      }) || {
        id: wordId
      };
    }
  }, {
    key: "position",
    value: function position(wordId) {
      for (var _i = 0, _Object$entries = Object.entries(((_this$context2 = this.context) === null || _this$context2 === void 0 ? void 0 : _this$context2.pages) || {}); _i < _Object$entries.length; _i++) {
        var _this$context2;
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          page = _Object$entries$_i[0],
          wordIds = _Object$entries$_i[1];
        var index = wordIds.indexOf(wordId);
        if (index !== -1) {
          return {
            page: Number(page),
            index: index,
            wordIds: wordIds
          };
        }
      }
    }
  }, {
    key: "canNavigate",
    value: function canNavigate(wordId, direction) {
      var position = this.position(wordId);
      if (!position) {
        return false;
      }
      if (position.wordIds[position.index + direction]) {
        return true;
      }
      return direction === -1 ? position.page > (this.context.firstPage || 1) : this.context.lastPage == null || position.page < this.context.lastPage;
    }
  }, {
    key: "adjacent",
    value: function () {
      var _adjacent = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(wordId, direction) {
        var _this = this;
        var position, adjacentId, page, _loop, _ret, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.loading || !this.canNavigate(wordId, direction))) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              position = this.position(wordId);
              adjacentId = position.wordIds[position.index + direction];
              if (!adjacentId) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2, adjacentId);
            case 2:
              this.loading = true;
              this.error = false;
              _context2.p = 3;
              page = position.page + direction;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var wordIds, store, response;
                return _regenerator().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      wordIds = _this.context.pages[page];
                      if (wordIds) {
                        _context.n = 2;
                        break;
                      }
                      store = new _stores.WordStore.constructor();
                      store.setPage(page);
                      store.setLimit(_this.context.limit);
                      _context.n = 1;
                      return new Promise(function (resolve, reject) {
                        store.getIndex({
                          filters: (0, _lodash.cloneDeep)(_this.context.filters),
                          sort: _this.context.sort,
                          queryStrings: _this.context.queryStrings,
                          failureCallback: reject,
                          onRequestError: reject,
                          timeout: 15000
                        }, resolve);
                      });
                    case 1:
                      response = _context.v;
                      store.setIndexData(response);
                      wordIds = store.indexData.filter(function (word) {
                        return word.publicInVocab;
                      }).map(function (word) {
                        return word.id;
                      });
                      _this.context = _objectSpread(_objectSpread({}, _this.context), {}, {
                        pages: _objectSpread(_objectSpread({}, _this.context.pages), {}, _defineProperty({}, page, wordIds)),
                        words: _objectSpread(_objectSpread({}, _this.context.words), DictionaryNavigation.wordData(store)),
                        lastPage: store.totalCount != null ? Math.ceil(store.totalCount / _this.context.limit) : store.indexData.length < _this.context.limit ? page : _this.context.lastPage
                      });
                    case 2:
                      if (!wordIds.length) {
                        _context.n = 3;
                        break;
                      }
                      return _context.a(2, {
                        v: direction === 1 ? wordIds[0] : wordIds[wordIds.length - 1]
                      });
                    case 3:
                      page += direction;
                    case 4:
                      return _context.a(2);
                  }
                }, _loop);
              });
            case 4:
              if (!(page >= 1 && (this.context.lastPage == null || page <= this.context.lastPage))) {
                _context2.n = 7;
                break;
              }
              return _context2.d(_regeneratorValues(_loop()), 5);
            case 5:
              _ret = _context2.v;
              if (!_ret) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2, _ret.v);
            case 6:
              _context2.n = 4;
              break;
            case 7:
              this.context = _objectSpread(_objectSpread({}, this.context), {}, _defineProperty({}, direction === 1 ? 'lastPage' : 'firstPage', position.page));
              _context2.n = 9;
              break;
            case 8:
              _context2.p = 8;
              _t = _context2.v;
              this.error = true;
            case 9:
              _context2.p = 9;
              this.loading = false;
              return _context2.f(9);
            case 10:
              return _context2.a(2);
          }
        }, _callee, this, [[3, 8, 9, 10]]);
      }));
      function adjacent(_x, _x2) {
        return _adjacent.apply(this, arguments);
      }
      return adjacent;
    }()
  }], [{
    key: "fromStore",
    value: function fromStore(store) {
      var queryStrings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        vocab_list: true
      };
      var page = Number(store.page) || 1;
      return {
        pages: _defineProperty({}, page, store.indexData.filter(function (word) {
          return word.publicInVocab;
        }).map(function (word) {
          return word.id;
        })),
        words: DictionaryNavigation.wordData(store),
        filters: (0, _lodash.cloneDeep)((0, _mobx.toJS)(store.filters)),
        sort: store.sort,
        limit: store.limit,
        queryStrings: queryStrings,
        lastPage: store.totalCount != null ? Math.ceil(store.totalCount / store.limit) : store.indexData.length < store.limit ? page : null
      };
    }
  }, {
    key: "wordData",
    value: function wordData(store) {
      var words = Object.fromEntries(store.indexData.filter(function (word) {
        return word.publicInVocab;
      }).map(function (word) {
        return [word.id, (0, _serializr.serialize)(word)];
      }));
      // Custom model serializers can retain MobX observables that browser history cannot clone.
      return JSON.parse(JSON.stringify(words));
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "context", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "loading", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _class);